import { memo } from "react";

const HidePasswordIcon = memo(function HidePasswordIcon({
  className,
  setShowPassword,
  showPassword,
}: {
  className: string;
  setShowPassword: React.Dispatch<React.SetStateAction<boolean>>;
  showPassword: boolean;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="#eee"
      id="Eye-Slash--Streamline-Heroicons"
      height="16"
      width="16"
      aria-hidden="true"
      className={`cursor-pointer ${className}`}
      onClick={() => setShowPassword(!showPassword)}
    >
      <desc>Eye Slash Streamline Icon: https://streamlinehq.com</desc>
      <path
        d="M2.9416666666666664 2.0583333333333336a0.625 0.625 0 0 0 -0.8833333333333334 0.8833333333333334l15 15a0.625 0.625 0 1 0 0.8833333333333334 -0.8833333333333334l-15 -15Zm15.955000000000002 8.4025a9.374166666666667 9.374166666666667 0 0 1 -2.1925 3.5916666666666663l-2.5825000000000005 -2.5825000000000005a4.375 4.375 0 0 0 -5.591666666666667 -5.591666666666667L6.465833333333334 3.814166666666667a9.3475 9.3475 0 0 1 3.535 -0.6891666666666667c4.141666666666667 0 7.654166666666668 2.6858333333333335 8.895833333333334 6.408333333333334 0.1 0.3016666666666667 0.1 0.6266666666666667 0 0.9275Z"
        strokeWidth="0.8333"
      ></path>
      <path
        d="M13.125 10c0 0.15 -0.010833333333333334 0.2975 -0.030833333333333334 0.4416666666666667l-3.5366666666666666 -3.5358333333333336A3.125 3.125 0 0 1 13.125 10Zm-2.6833333333333336 3.0941666666666667 -3.5358333333333336 -3.5366666666666666a3.125 3.125 0 0 0 3.5366666666666666 3.5358333333333336Z"
        strokeWidth="0.8333"
      ></path>
      <path
        d="M5.625 10c0 -0.5158333333333334 0.08916666666666667 -1.0108333333333335 0.25333333333333335 -1.47l-2.5833333333333335 -2.5833333333333335a9.375 9.375 0 0 0 -2.191666666666667 3.5916666666666663c-0.1 0.3016666666666667 -0.1 0.6266666666666667 0 0.9283333333333335 1.2408333333333335 3.7224999999999997 4.753333333333333 6.408333333333334 8.895833333333334 6.408333333333334 1.25 0 2.444166666666667 -0.245 3.535 -0.6891666666666667l-2.0641666666666665 -2.0641666666666665A4.375 4.375 0 0 1 5.625 10Z"
        strokeWidth="0.8333"
      ></path>
    </svg>
  );
});

export default HidePasswordIcon;
